import React, {useContext, useEffect, useState} from 'react';
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow
} from '@mui/material';
import {DispatchContext} from '../../../store';
import {useNavigate} from 'react-router-dom';
import Moment from 'react-moment';
import {transfersApi} from '../../../services/TransferServices';

export default function TransferTable({status, meta, setMeta}) {
  const dispatch = useContext(DispatchContext);
  const navigate = useNavigate();
  const [transfers, setTransfers] = useState([]);
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const getDisplayValue = (value) => {
    if (!value) return '-';
    if (typeof value === 'object') {
      return value?.name || value?.code || '-';
    }
    return value;
  };

  useEffect(() => {
    getTransfersList();
  },[page, rowsPerPage]);

  const getTransfersList = () => {
    transfersApi('get', null, {state: status, page: page, per_page: rowsPerPage}).then(res => {
      setTransfers(res?.data);
      setMeta(res?.meta);
    })
  }

  const handleDetail = (id) => {
    navigate(`/management/transfers/${id}`);
  }

  const handleChangePage = (event, newPage) => {
    dispatch({type: 'IS_NOT_LOADING', payload: false});
    setPage(newPage + 1);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(1);
  };

  return (
    <div>
      <TableContainer component={Paper}>
        <Table sx={{minWidth: 650}} aria-label="caption table">
          <TableHead>
            <TableRow>
              <TableCell sx={{color: '#B3B3B3'}}>Sl.No.</TableCell>
              <TableCell align="left" sx={{color: '#B3B3B3'}}>Submission Date</TableCell>
              <TableCell align="left" sx={{color: '#B3B3B3'}}>Accession No.</TableCell>
              <TableCell align="left" sx={{color: '#B3B3B3'}}>Object Name</TableCell>
              <TableCell align="left" sx={{color: '#B3B3B3'}}>Materials</TableCell>
              <TableCell align="left" sx={{color: '#B3B3B3'}}>Recipient Museum Name</TableCell>
              <TableCell align="left" sx={{color: '#B3B3B3'}}>Classification</TableCell>
              <TableCell align="left" sx={{color: '#B3B3B3'}}>Status</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {transfers?.length > 0 && transfers?.map((transfer, index) => (
              <TableRow key={index} hover onClick={() => handleDetail(transfer?.id)}>
                <TableCell sx={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                  {index + 1}
                </TableCell>
                <TableCell align="left"><Moment format={'ll'}>{transfer?.created_at}</Moment></TableCell>
                <TableCell align="left">{getDisplayValue(transfer?.accession_no)}</TableCell>
                <TableCell align="left">{transfer?.catalogue?.object_name || '-'}</TableCell>
                <TableCell align="left">{getDisplayValue(transfer?.catalogue?.material)}</TableCell>
                <TableCell align="left">{transfer?.recipient_museum_name|| '-'}</TableCell>
                <TableCell align="left">{getDisplayValue(transfer?.catalogue?.object_group)}</TableCell>
                <TableCell align="left" className={'text-capitalize'}>{transfer?.state|| '-'}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[5, 10, 100]}
        page={page - 1}
        rowsPerPage={rowsPerPage}
        component="div"
        count={meta?.total}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </div>
  );
}